import React from 'react'

const PageFeaturedColumns = ({ slice }) => {
    return (
        <section className="featured-columns">
            <div className="container">
                <div className="three-columns">
                    <div>
                        <img src={slice.primary.left_image.url} alt={slice.primary.left_image.alt} />
                        <p className="font-large font-heavy margin-none mt-12">{slice.primary.left_header.text}</p>
                        <p>{slice.primary.left_description.text}</p>
                        <a href={slice.primary.left_link.url} className="link">{slice.primary.left_link_text.text}</a>
                    </div>
                    <div>
                        <img src={slice.primary.center_image.url} alt={slice.primary.center_image.alt} />
                        <p className="font-large font-heavy margin-none mt-12">{slice.primary.center_header.text}</p>
                        <p>{slice.primary.center_description.text}</p>
                        <a href={slice.primary.center_link.url} className="link">{slice.primary.center_link_text.text}</a>
                    </div>
                    <div>
                        <img src={slice.primary.right_image.url} alt={slice.primary.right_image.alt} />
                        <p className="font-large font-heavy margin-none mt-12">{slice.primary.right_header.text}</p>
                        <p>{slice.primary.right_description.text}</p>
                        <a href={slice.primary.right_link.url} className="link">{slice.primary.right_link_text.text}</a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PageFeaturedColumns